module.exports = __webpack_public_path__ + "static/media/footer-logo.9d5c8c30.svg";